import axios from "axios";
import axiosInstance from "../utils/httpCommon";

const getProductList = async (queryParams) => {
    let path = `/listaProductos?` + queryParams;
    try {
        const resp = await axiosInstance.get(path);
        return resp.data;
    } catch (err) {
        throw axios.isAxiosError(err)
        ? err
        : new Error("Fetch get list products failed");
    }
};

const getProductDetail = async (isin) => {
    const path = `/detalleProductos/${isin}`;
    // const path ="http://localhost:3002/item";
    try {
        const resp = await axiosInstance.get(path);
        return resp.data;
    } catch (err) {
        throw axios.isAxiosError(err)
        ? err
        : new Error("Fetch get product detail failed");
    }
};

const getHistorical = async (isin) => {
    const path = `/historico/${isin}`;
    try {
        const resp = await axiosInstance.get(path);
        return resp.data;
    } catch (err) {
        throw axios.isAxiosError(err)
        ? err
        : new Error("Fetch get product detail failed");
    }
};

const getProductListObject = async (isin) => {
    let path = `/listaProductos?nombre=${isin}`;
    try {
        const response = await axiosInstance.get(path);
        return response.data.response.find((element) => element.isin === isin);
    } catch (err) {
        throw axios.isAxiosError(err)
        ? err
        : new Error("Fetch get list products failed");
    }
};

const exportProductsExcel = async (queryParams) => {
    let path =`/listaProductos/exportExcel?${queryParams}`;
    try {
        const response = await axiosInstance.get(path);
        downloadFile(response.data, "listaProductos", "xlsx");
    } catch (err) {
        throw axios.isAxiosError(err)
        ? err
        : new Error("Fetch excel file failed");
    }
};

const exportProductsPDF = async (queryParams) => {
    let path =`/listaProductos/exportPdf?${queryParams}`;
    try {
        const response = await axiosInstance.get(path);
        downloadFile(response.data, "listaProductos", "pdf");
    } catch (err) {
        throw axios.isAxiosError(err)
        ? err
        : new Error("Fetch pdf file failed");
    }
};

const exportProductsExcelHistorico = async (isin) => {
    let path =`/detalleProductos/${isin}/exportExcel`;
    try {
        const response = await axiosInstance.get(path);
        downloadFile(response.data, "listaProductos", "xlsx");
    } catch (err) {
        throw axios.isAxiosError(err)
        ? err
        : new Error("Fetch excel file failed");
    }
};

const exportProductsPDFHistorico = async (isin) => {
    let path =`/detalleProductos/${isin}/exportPdf`;
    try {
        const response = await axiosInstance.get(path);
        downloadFile(response.data, "listaProductos", "pdf");
    } catch (err) {
        throw axios.isAxiosError(err)
        ? err
        : new Error("Fetch pdf file failed");
    }
};

const downloadFile = (file, name, extension) => {
    let anchor = window.document.createElement('a');
    let currentDate = getFormattedDate();
    anchor.download =  name + "_" + currentDate + "." + extension;
    if (extension === "pdf") {
        anchor.href = "data:application/pdf;base64," + file;
    }
    if (extension === "xlsx") {
        anchor.href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + file;
    }
    anchor.click();
};

const getRentaResume = async (isin, startDate, endDate, productType) => {
    // const path = `/${isin}/rentabilidad/${dateParam}`;
    let prodType
    if (productType === 'planes'){
        prodType = 'plan';
    } else if (productType === 'sicav'){
        prodType = 'sicav';
    } else if (productType === 'epvs'){
        prodType = 'epsv';
    } else {
        prodType = 'fondo';
    }
    const path = `https://www.santanderassetmanagement.es/buscadorproductosback/` + prodType +  `/` + isin +  `/rentabilidad/?fechafin=` + endDate + `&fechainicio=` + startDate;
    try {
        const resp = await axiosInstance.get(path);
        return resp.data;
    } catch (err) {
        throw axios.isAxiosError(err)
        ? err
        : new Error("Fetch get renta resume failed");
    }
};

const getFormattedDate = () => {
    const date = new Date();
    const year = date.getFullYear();

    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}${month}${day}`;
};

export const productServices = {
    getProductList,
    getProductDetail,
    getHistorical,
    getProductListObject,
    exportProductsExcel,
    exportProductsPDF,
    getRentaResume,
    exportProductsExcelHistorico,
    exportProductsPDFHistorico,
};
